import { RouteConfig } from 'vue-router'
const router: Array<RouteConfig> = [
  {
    path: '/farmingCalendar',
    name: 'farmingCalendar',
    meta: { title: '农事日历' },
    component: () => import('@/views/farmingCalendar/Calendar.vue')
  },
  {
    path: '/farmingCalendar/manage',
    name: 'farmingCalendarManage',
    meta: { title: '农事指导管理' },
    component: () => import('@/views/farmingCalendar/Guide.vue')
  }
]

export default router
